/* eslint-disable sonarjs/no-duplicate-string */
import { Plan } from '../../../types';

export const aidaPlans: Plan[] = [
	{
		id: `11edf0cb38bde6b8be4756d616304957`,
		alias: `alias`,
		name: `Starter Pack`,
		description: `Базовый набор отчетов для знакомства с продуктом`,
		features: {
			main: [
				{
					text: `Выручка за период`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке`,
					includedInFree: true,
				},
				{
					text: `Заказов на курьера в час`,
					includedInFree: true,
				},
				{
					text: `Средняя скорость доставки`,
					includedInFree: true,
				},
				{
					text: `Заказы с доставкой от 30 мин.`,
					includedInFree: true,
				},
				{
					text: `Стопы по ингредиентам`,
					includedInFree: true,
				},
				{
					text: `Стопы по каналам`,
					includedInFree: true,
				},
				{
					text: `Продуктов на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Выручка на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Скорость зал: Ожидание I Приготовление`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке для доставки`,
					includedInFree: true,
				},
				{
					text: `Сертификаты за опоздания: курьеры`,
					includedInFree: true,
				},
				{
					text: `Стопы по продуктам`,
					includedInFree: true,
				},
			],
			all: null,
		},
		price: 0,
		subscriptionPeriod: null,
		isFree: true,
		isActive: false,
		additional: null,
	},
	{
		id: `11edf0cb38bde6b8be4756d616312904`,
		alias: `alias`,
		name: `Advanced`,
		description: `Расширенный набор отчетов для принятия управленческих решений`,
		features: {
			main: [
				{
					text: `Выручка за период`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке`,
					includedInFree: true,
				},
				{
					text: `Заказов на курьера в час`,
					includedInFree: true,
				},
				{
					text: `Средняя скорость доставки`,
					includedInFree: true,
				},
				{
					text: `Заказы с доставкой от 30 мин.`,
					includedInFree: true,
				},
				{
					text: `Стопы по ингредиентам`,
					includedInFree: true,
				},
				{
					text: `Стопы по каналам`,
					includedInFree: true,
				},
				{
					text: `Продуктов на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Выручка на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Скорость зал: Ожидание I Приготовление`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке для доставки`,
					includedInFree: true,
				},
				{
					text: `Сертификаты за опоздания: курьеры`,
					includedInFree: true,
				},
				{
					text: `Стопы по продуктам`,
					includedInFree: true,
				},
				{
					text: `Стопы по продуктам`,
					includedInFree: true,
				},
			],
			all: [
				{
					title: `Персонал`,
					features: [
						{
							text: `Должности сотрудников`,
							includedInFree: false,
						},
						{
							text: `Медицинские книжки`,
							includedInFree: false,
						},
					],
				},
				{
					title: `Списание и брак`,
					features: [
						{
							text: `Забракованные продукты`,
							includedInFree: false,
						},
						{
							text: `Питание персонала`,
							includedInFree: false,
						},
					],
				},
				{
					title: `Стопы`,
					features: [
						{
							text: `Стоп по каналам продаж`,
							includedInFree: false,
						},
						{
							text: `Стоп по секторам. Только активные`,
							includedInFree: false,
						},
					],
				},
				{
					title: `Выручка`,
					features: [
						{
							text: `Выручка + LFL к году + Прогноз на месяц`,
							includedInFree: false,
						},
						{
							text: `Выручка на человека в час`,
							includedInFree: false,
						},
					],
				},
				{
					title: `Доставка`,
					features: [
						{
							text: `Количество заказов с доставкой от 30 минут`,
							includedInFree: false,
						},
						{
							text: `Статистика по времени ожидания на полке для доставки`,
							includedInFree: false,
						},
						{
							text: `Сертификаты за опоздание: Количество`,
							includedInFree: false,
						},
						{
							text: `Сертификаты за опоздание: Курьеры`,
							includedInFree: false,
						},
						{
							text: `Сертификаты за опоздание: Количество с курьерами`,
							includedInFree: false,
						},
						{
							text: `Кол-во доставок дольше предполагаемого времени`,
							includedInFree: false,
						},
						{
							text: `Процент доставок с одним заказом`,
							includedInFree: false,
						},
						{
							text: `Долгие ожидания курьера`,
							includedInFree: false,
						},
					],
				},
				{
					title: `Производительность`,
					features: [
						{
							text: `Скорость зал: Ожидание / Приготовление`,
							includedInFree: false,
						},
						{
							text: `Баланс эффективности`,
							includedInFree: false,
						},
						{
							text: `Сводный отчет за вчера`,
							includedInFree: false,
						},
						{
							text: `Статистика отказов заказов`,
							includedInFree: false,
						},
					],
				},
			],
		},
		price: 990,
		subscriptionPeriod: `мес.`,
		isFree: false,
		isActive: false,
		additional: null,
	},
	{
		id: `11edf0cb38bde6b8be4756d616302385`,
		alias: `alias`,
		name: `Ultima`,
		description: `Максимальный набор отчетов с возможностью подключить кастомные отчеты`,
		features: {
			main: [
				{
					text: `Выручка за период`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке`,
					includedInFree: true,
				},
				{
					text: `Заказов на курьера в час`,
					includedInFree: true,
				},
				{
					text: `Средняя скорость доставки`,
					includedInFree: true,
				},
				{
					text: `Заказы с доставкой от 30 мин.`,
					includedInFree: true,
				},
				{
					text: `Стопы по ингредиентам`,
					includedInFree: true,
				},
				{
					text: `Стопы по каналам`,
					includedInFree: true,
				},
				{
					text: `Продуктов на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Выручка на человека в час за период`,
					includedInFree: true,
				},
				{
					text: `Скорость зал: Ожидание I Приготовление`,
					includedInFree: true,
				},
				{
					text: `Время ожидания на полке для доставки`,
					includedInFree: true,
				},
				{
					text: `Сертификаты за опоздания: курьеры`,
					includedInFree: true,
				},
				{
					text: `Стопы по продуктам`,
					includedInFree: true,
				},
				{
					text: `Стопы по продуктам`,
					includedInFree: true,
				},
			],
			all: null,
		},
		price: 1990,
		subscriptionPeriod: `мес.`,
		isFree: false,
		isActive: false,
		additional: [
			{
				text: `Списание ингредиентов`,
				price: 100,
			},
			{
				text: `Что-то еще`,
				price: 100,
			},
		],
	},
];
